import { ImageIcon, Star } from 'lucide-react';
import { Button, Card, CardBody, SourceSection } from '@/shared/components';
import type { PropertyFileResponse } from '@/shared/api';
import { AuthenticatedImage } from './AuthenticatedImage';

interface CoverCardProps {
  propertyId: string;
  propertyName: string;
  cover: PropertyFileResponse | null;
  onClear: () => void;
  clearing: boolean;
}

export function CoverCard({ propertyId, propertyName, cover, onClear, clearing }: CoverCardProps) {
  return (
    <Card className="mb-6">
      <CardBody className="p-6">
        <SourceSection
          source="internal"
          eyebrow="Cover-Bild"
          subtitle="Wird in der Apartment-Liste angezeigt. Geht NICHT zu OTAs — Airbnb/Booking pflegst du dort."
        />
        {cover ? (
          <div className="flex flex-col gap-6 sm:flex-row">
            <div className="border-line/60 relative w-full shrink-0 overflow-hidden rounded-md border sm:w-80">
              <AuthenticatedImage
                propertyId={propertyId}
                fileId={cover.id}
                variant="medium"
                alt={`Cover ${propertyName}`}
                className="aspect-4/3 w-full"
              />
              <span className="bg-sage absolute left-2.5 top-2.5 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.08em] text-white">
                <Star className="size-2.5 fill-current" aria-hidden />
                Cover
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-between gap-4">
              <div>
                <p className="text-ink break-all font-mono text-sm">{cover.fileName}</p>
                <p className="text-ink-faint mt-1 text-xs">
                  {Math.round(cover.sizeBytes / 1024)} KB · {cover.contentType}
                </p>
                <p className="text-ink-soft mt-3 max-w-sm text-xs leading-relaxed">
                  Ein anderes Cover setzt du über <em>Als Cover</em> an jedem Bild in der Galerie.
                </p>
              </div>
              <div>
                <Button variant="ghost" size="sm" onClick={onClear} loading={clearing}>
                  Cover entfernen
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="border-line/70 bg-card-alt/50 flex items-center gap-4 rounded-md border border-dashed p-6">
            <span className="text-ink-faint bg-card flex size-12 shrink-0 items-center justify-center rounded-full">
              <ImageIcon className="size-5" aria-hidden />
            </span>
            <p className="text-ink-soft text-sm">
              Noch kein Cover gesetzt. Lade unten ein Bild hoch — das erste wird automatisch Cover.
            </p>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
